import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/event_details`, {params: {...filter}})
  },

  indexByEvent({event_id, filter}) {
    return Http.get(`/events/${event_id}/event_details`, {params: {...filter}})
  },


  create(event_detail){
    return Http.post(`/event_details`, {event_detail: {
      ...event_detail,
    }})
  },

  update(event_detail){
    return Http.put(`/event_details/${event_detail.id}`, {
      event_detail: {
        ...event_detail,
      },
    });
  },

  show(id) {
    return Http.get(`/event_details/${id}`);
  },

  delete(id){
    return Http.delete(`/event_details/${id}`)
  }

}